/*
----------------------------
Module - claims-connect
----------------------------
*/

import $ from 'jquery';
/*global fmg*/

(function(){
    'use strict';
    
    fmg.claimFlow = function(){
        
        function setupBrowserBackForwardButtons() {

            window.addEventListener('popstate', (event) => {

                fetchPage(window.location.href, function() {

                    refreshForm();

                });

            });

         }

        function setupClickHandlers() {
            
            $("body").on("click", grid_links_class + "," + progression_bar_steps_links_class + "," + claim_back_btn_class + "," + call_invite_btn_class, function(event) {

                var $this_link = $(this);

                if ($this_link.attr("target") != "_blank") {
                    
                    event.preventDefault();

                    var page_url = $this_link.prop("href");

                    fetchPage(page_url, function() {

                        window.history.pushState("", "", page_url);

                        // Need this to run in callback because need the query parameters set by pushState
                        refreshForm();

                    });
                    
                }

            });

        }
        
        var fetchPage = fmg.fn.debounce(function (page_url, callback) {
            
            var page_url_data = page_url.split("?");
            var request_url = page_url;

            if (page_url_data.length > 1) {
                request_url += "&";
            } else {
                // This is for requesting page 1 which has no parameters
                request_url += "?";
            }

            // By requesting the SQ_ASSET_CONTENTS version, performance is faster
            request_url += "SQ_ASSET_CONTENTS";

            $main.load( request_url, function() {
                
                // Scroll back to top of progression bar
                $("html,body").animate({
                    scrollTop: $(".page-header__steps").offset().top - 120
                });

                if (callback) {
                    callback();
                }

                // Everytime you ajax in a new page, the invisible class on the wrapper will be back
                // Remove it
                revealHiddenContent();

            });

        }, 300);

        function refreshForm() {

            var $form_embed = $(".form-embed");

            if ( $(".form-embed").length ) {
                
                // Set up form dependency again
                form_dependent_group_module.init();

                // Set up this form
                fmg.addAriaLiveAttribute($form_embed);
                fmg.addAsteriskToLabels($form_embed);
                fmg.setupTextFields($form_embed);
                fmg.setupSelectFields($form_embed);
                fmg.setupDatetimeFields($form_embed);
                fmg.setupMonthPickerFields($form_embed);
                fmg.setupFileInputs($form_embed);
                fmg.setupAddressFields($form_embed);

                // Validation
                fmg.formValidation($form_embed);
                fmg.formValidationCustomRules($form_embed);

                // Set up submission handler
                fmg.formEmbed.init();

                populateForm();

            }
            
        }

        function populateForm() {
            
            // decodeURIComponent to decode characters like "%20" into " "
            var claim_type = decodeURIComponent(fmg.fn.getQueryParameter("esi_claim_type"));
            var claim_subtype = decodeURIComponent(fmg.fn.getQueryParameter("esi_claim_subtype"));

            var $claim_type_checkboxes = $("input[name='q7004:q3[]']");
            var $claim_contents_select = $("select[name='q7007:q1']");
            var $claim_other_select = $("select[name='q7010:q1']");
            
            switch(claim_type){
                
                case "Vehicle":
                    
                    $claim_type_checkboxes.filter("input[value=0]").prop('checked', true).trigger("change");
                    break;

                case "Contents":
                    
                    if (claim_subtype == "Milk"){

                        // Milk is the exceptional "Contents claim subtype" which results in only Other claim type and Milk ticked
                        $claim_other_select.val("Milk").trigger("change");
                        $claim_type_checkboxes.filter("input[value=4]").prop('checked', true).trigger("change");

                    } else {

                        $claim_type_checkboxes.filter("input[value=1]").prop('checked', true).trigger("change");

                        if (claim_subtype == "House and Contents"){
                            // Buildings
                            $claim_type_checkboxes.filter("input[value=2]").prop('checked', true).trigger("change");
                        }
                    }

                    break;

                case "House and Building":
                    
                    $claim_type_checkboxes.filter("input[value=2]").prop('checked', true).trigger("change");

                    if(claim_subtype == "House and Contents"){
                        // Buildings
                        $claim_type_checkboxes.filter("input[value=1]").prop('checked', true).trigger("change");
                    }

                    break;

                case "Other":
                
                    $claim_type_checkboxes.filter("input[value=4]").prop('checked', true).trigger("change");
    
                default:
            }

            switch(claim_subtype){
                
                case "Baled Hay":
                case "Farm Contents":
                    
                    $claim_contents_select.val("Farm").trigger("change");
                    break;

                case "Commercial Contents":
                case "Portable Plant and Equipment":
                case "Stock":

                    $claim_contents_select.val("Commercial").trigger("change");
                    break;
                    
                
                case "Electronic item":
                case "Household Contents":
                case "Spectacles":
                case "Hearing aids":
                case "House and Contents":

                    $claim_contents_select.val("Residential").trigger("change");
                    break;

                default:
                    break;
                    
             }
        
        }

        function revealHiddenContent() {
            $main.find(make_a_claim_wrapper_class + ".invisible").removeClass("invisible");
        }

        function init(){
            
            if ($(make_a_claim_wrapper_class).length) {

                $main = $("main");

                setupClickHandlers();
                setupBrowserBackForwardButtons();

                // Need this to prepopulate values if user is visiting the page with the form directly
                if ( $(".form-embed").length ) {
                    populateForm()
                }

                // In Matrix, the main content below the header will be visibly hidden initially
                // Only after click handlers have been set up, we reveal the content
                revealHiddenContent();
                
            }

        }

        var make_a_claim_wrapper_class = ".make-a-claim";

        var $main;

        var claim_back_btn_class = ".claim-back-btn";
        var progression_bar_steps_links_class = "a.page-header__steps-link";
        var grid_links_class = ".icon-grid__item-link"
        var call_invite_btn_class = ".call-invite__claim-form-link";

        return {
            init: init
        };

    }()

    document.addEventListener("DOMContentLoaded", function () {
        fmg.claimFlow.init();
    });

}());
